// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"bd6878bd","817":"e95449a2"}[chunkId] + ".chunk.js";
};